import * as React from 'react';

import { FormattedHTMLMessage } from 'js/lib/coursera.react-intl';

import { Button, Chip, ChipGroup } from '@coursera/cds-core';

import type { FilterOption } from 'bundles/enterprise-admin-drawers/components/types';
import { formatNumber } from 'bundles/enterprise-ui';

import _t from 'i18n!nls/enterprise-admin-user-filters';

type Props = {
  label: string;
  filterOptions?: FilterOption[];
  values?: string[];
  numFiltersDisplayed: number;
  onDismiss: (id: string) => void;
  onMore?: () => void;
};

const FilterPills = ({ label, filterOptions, values, numFiltersDisplayed, onDismiss, onMore }: Props) => {
  const { length } = filterOptions ?? values ?? [];
  const more = (
    <FormattedHTMLMessage
      message={_t(`<strong>+{count} more</strong>`)}
      count={formatNumber(length - numFiltersDisplayed)}
    />
  );

  return (
    <React.Fragment>
      <ChipGroup label={label} variant="delete">
        {values?.slice(0, numFiltersDisplayed).map((filter) => (
          <Chip key={filter} variant="delete" onClick={() => onDismiss(filter)} data-testid="FilterPill_button">
            {filter}
          </Chip>
        )) ??
          filterOptions?.slice(0, numFiltersDisplayed).map((filter) => (
            <Chip key={filter.id} variant="delete" onClick={() => onDismiss(filter.id)} data-testid="FilterPill_button">
              {filter.label}
            </Chip>
          )) ??
          []}
      </ChipGroup>
      {length > numFiltersDisplayed ? (
        <React.Fragment>
          {onMore ? (
            <Button variant="ghost" onClick={onMore}>
              {more}
            </Button>
          ) : (
            more
          )}
        </React.Fragment>
      ) : null}
    </React.Fragment>
  );
};

export default FilterPills;
